<template>
  <div class="flex flex_items">
    <!--面包屑-->
    <img src="@/assets/index/s-icon.png" class="s-icon"><span style="color:#909399">当前位置：</span>
    <el-breadcrumb class="breadcrumb" separator="/" style="margin-top: 4px;">
      <!--默认给一个首页的跳转，如果不需要可以去掉-->
      <!-- <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item v-if="breadcrumbFirName">{{breadcrumbFirName}}</el-breadcrumb-item>
      <!--面包屑列表-->
      <el-breadcrumb-item v-for="(item, index) in breadList" :key="index" @click.native="breadcrumbClick(item)"
        style="cursor: pointer">
        {{ item.showName || item.name }} 
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import {navlist} from '@/utils/settings'
export default {
  data() {
    return {
      levelList: null,
      breadList: [],
      breadcrumbFirName:''
    };
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      this.breadcrumbFirName = navlist[route.meta.belong].showName
      
      if (route.path.startsWith("/redirect/")) {
        return;
      }
      this.getBreadcrumb();
    },
    "$store.getters.breadListState": {
      handler: function(params) {
        this.breadList = params;
      },
      deep: true
    },


  },
  created() {
    this.getBreadcrumb();
    let route = this.$route;
    this.breadcrumbFirName = navlist[route.meta.belong].showName;
  },
  methods: {
    getBreadcrumb() {
      // console.log(this.$store.getters.breadListState,'===bre');
      this.breadList = this.$store.getters.breadListState;
      return
      let that = this;
      // 由于本项目大部分属于‘一级’页面，所以在设置路由时候，一级页面不设置breadNumber = 1，‘二级’页面以上才设置breadNumber
      let breadNumber = typeof (this.$route.meta.breadNumber) !== 'undefined' ? this.$route.meta.breadNumber : 1;
      // 获取当前页面的名字和路由，并组合成新的对象
      let newBread = { name: this.$route.name, path: this.$route.fullPath ,showName:this.$route.meta.proName ? this.$route.meta.proName : this.$route.meta.title};
      // console.log(newBread,'a=');
      
      let vuexBreadList = []; // 默认初始化面包屑数据
      if (breadNumber !== 1) {
        // 当前面包屑breadNumber大于1时才会从vuex中获取值
        vuexBreadList = that.$store.state.app.breadListState; // 获取breadList数组
      }
      if (breadNumber < vuexBreadList.length) {
        // "回退"面包屑----判断条件：当前路由breadNumber小于vuexBreadList的长度
        vuexBreadList.splice(breadNumber - vuexBreadList.length, vuexBreadList.length - breadNumber);
      }
      if (breadNumber > vuexBreadList.length) {
        // 添加面包屑----判断条件：当前路由breadNumber大于vuexBreadList的长度
        vuexBreadList.push(newBread);
      }
      // 处理完数据后，将最终的数据更新到vuex（用于页面刷新）
      console.log(vuexBreadList,'a====');
      
      that.$store.dispatch('app/setBreadListMutations', vuexBreadList)
      // that.$store.commit('breadListMutations', vuexBreadList);
      // 处理完数据后，将最终的数据更新为新的面包屑数组
      // console.log(vuexBreadList,'=aaa==');
      
      that.breadList = vuexBreadList;
    },
    breadcrumbClick(item) {
      console.log('push');
      this.$router.push({
        path: item.path
      })
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.el-breadcrumb {
  font-size: $pageFont;
}

.s-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  display: block;
}
</style>
<style lang="scss">
@import "~@/styles/variables.scss";
.el-breadcrumb__inner.is-link {
  color: #909399 !important;
  font-weight: normal;
}
.el-breadcrumb__inner{
  color: #666 !important;
  font-size: $pageFont;
}
</style>
